import React, { Component } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { reaction } from 'mobx'
import AnimateHeight from 'react-animate-height'
import TemplateCustomTagStore from './store'
import Checkbox from '../form/Checkbox'
import '../TemplateAccess/template-access.scss'
import Button from '../../UniformComponents/Button'

@observer
class TemplateCustomTags extends Component {
    constructor(props) {
        super(props)
        const { appStore, exposeUpdateBody, templateParams } = props
        this.templateTagStore = new TemplateCustomTagStore(appStore, exposeUpdateBody, templateParams)

        reaction(
            () => [
                this.props.templateParams.productType,
                this.props.templateParams.surveyType,
                this.props.templateParams.respondentType,
            ],
            ([productType, surveyType, respondentType]) => {
                if (productType && surveyType && respondentType) {
                    this.templateTagStore.templateParams = this.props.templateParams
                    this.templateTagStore.init()
                }
            }
        )
    }

    async componentDidMount() { await this.templateTagStore.init() }

    renderCheckbox = ({ tagId, option }) => {
        const { toggleCheckbox, recordTags, updating } = this.templateTagStore
        const checked = recordTags.find((tag) => tag.tagId === tagId && tag.optionId === option.optionId)
        return (
            <div className="form-checkbox-wrapper">
                <Checkbox
                    onBlur={(obj, e) => toggleCheckbox(obj, e)}
                    name={tagId}
                    checked={Boolean(checked)}
                    valueid={option.optionId}
                    disabled={updating}
                    stopPropagation
                />
            </div>
        )
    }

    renderSubmitButton = () => {
        const { updateTemplateCustomTags, updating } = this.templateTagStore
        const { isNewTemplate } = this.props
        return !isNewTemplate && (
            <Button
                style={{ width: '80px' }}
                cssClass="uc-button regular save-button"
                variant="tertiary"
                onClick={updateTemplateCustomTags}
                disabled={updating}
                label={i18n.t('save')}
                icon="fal fa-floppy-disk"
            />
        )
    }

    getOptionTitle = (option) => {
        const { appStore: { langcode } } = this.props
        const firstLang = Object.keys(option.optionConfig.langs)[0]
        return option.optionConfig.langs[langcode] 
            || option.optionConfig.langs['en_GB']
            || option.optionConfig.langs[firstLang]
    }

    render() {
        const { availableTags, isAccOpen } = this.templateTagStore
        if (availableTags.length < 1) return null

        return (
            <div className="check-acc-wrapper">
                <div className="check-acc">
                    <div className="check-acc-header">
                        <i className="header-icon fa-solid fa-circle-info" />
                        <p className="header-label">{i18n.t('templates.customTags.title')}</p>
                        {this.renderSubmitButton()}
                    </div>
                    <div className="check-acc-body">
                        <hr className="acc-divider" />
                        <div className="option-list">
                            {availableTags.map((t) => (
                                <div className="option" key={`${t.tagId}`}>
                                    {/* Question */}
                                    <div
                                        className="option-heading"
                                        onClick={() => { this.templateTagStore.expandCustomTag(t.tagId) }}
                                    >
                                        <i className={`option-icon fa-regular ${isAccOpen[t.tagId]
                                            ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                        />
                                        <p className="option-name">{t.description}</p>
                                    </div>
                                    <AnimateHeight
                                        className="option-acc"
                                        duration={250}
                                        height={isAccOpen[t.tagId] ? 'auto' : 0}
                                    >
                                        <hr className="option-divider" />
                                        <div className="checks">
                                            {/* Options */}
                                            {t.options.map((option) => (
                                                <div key={`${option.optionId}`} className="check-item">
                                                    <span>{this.getOptionTitle(option)}</span>
                                                    {this.renderCheckbox({ tagId: t.tagId, option })}
                                                </div>
                                            ))}
                                        </div>
                                    </AnimateHeight>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TemplateCustomTags
